import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    message: Yup.string().required(schema.isRequired),
  });
  return valid;
};

export default validationSchema;
